export const footer = {
  newsletter: {
    label: "Newsletter signup",
    inputLabels: {
      email: "Email",
      next: "Next",
      salutation: "Salutation",
      firstname: "First name",
      lastname: "Last name",
      company: "Company",
      address: "Address",
      postalCode: "Postal code",
      city: "City",
      privacyStatement: "Privacy statement",
      privacyStatementCheckbox:
        "I agree with Maagtechnic AG processing my personal data in order to fulfill my request. ",
      send: "Absenden",
    },
    requiredFieldsMissing: "Some required fields are missing",
  },
  socialMedia: {
    label: "Follow us on",
  },
  legal: {
    label: "Legal",
    links: {
      termsAndConditions: {
        link:
          "https://maagtechnic.ch/content/dam/ch/pdf/unternehmen/rechtliches/Maagtechnic%20AGB_DE_0819.pdf",
        text: "Terms and conditions",
      },
      imprint: {
        link: "https://maagtechnic.ch/de/ueber-uns/impressum/",
        text: "Imprint",
      },
      disclaimer: {
        link: "https://maagtechnic.ch/de/ueber-uns/disclaimer/",
        text: "Disclaimer",
      },
      privacy: {
        link: "https://maagtechnic.ch/de/privacy/",
        text: "Privacy",
      },
    },
  },
};
